var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-us"},[_c('CommonHeader'),_c('main',[_c('div',{staticClass:"content markdown-body",domProps:{"innerHTML":_vm._s(_vm.body)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }